import React from "react";

const ConfirmModal = ({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  loading = false,
}) => {
  if (!open) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h3 style={styles.title}>{title}</h3>

        <p style={styles.message}>{message}</p>

        <div style={styles.buttonBox}>
          <button
            style={styles.cancelBtn}
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </button>

          <button
            style={styles.confirmBtn}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Please Wait..." : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999,
  },

  modal: {
    width: "90%",
    maxWidth: "400px",
    background: "#fff",
    borderRadius: "10px",
    padding: "25px",
    textAlign: "center",
    boxShadow: "0 5px 20px rgba(0,0,0,0.2)",
  },

  title: {
    marginBottom: "10px",
    color: "#111827",
  },

  message: {
    color: "#4b5563",
    marginBottom: "20px",
    lineHeight: "1.5",
  },

  buttonBox: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
  },

  cancelBtn: {
    padding: "10px 18px",
    border: "none",
    borderRadius: "6px",
    background: "#e5e7eb",
    cursor: "pointer",
    fontWeight: "600",
  },

  confirmBtn: {
    padding: "10px 18px",
    border: "none",
    borderRadius: "6px",
    background: "#16a34a",
    color: "#fff",
    cursor: "pointer",
    fontWeight: "600",
  },
};

export default ConfirmModal;